import React from "react";
import "./FixedDecoration.css"
const FixedDecoration:React.FC = () => {
    return(
        <React.Fragment>
            <div className={"decoH RU"}/>
            <div className={"decoH RB"}/>
            <div className={"decoH LU"}/>
            <div className={"decoH LB"}/>
            <div className={"decoV RU"}/>
            <div className={"decoV RB"}/>
            <div className={"decoV LU"}/>
            <div className={"decoV LB"}/>
        </React.Fragment>
    );
}

export default FixedDecoration;